import { render, staticRenderFns } from "./abstractSuccessPC.vue?vue&type=template&id=b05056b0&scoped=true"
import script from "./abstractSuccessPC.vue?vue&type=script&lang=js"
export * from "./abstractSuccessPC.vue?vue&type=script&lang=js"
import style0 from "./abstractSuccessPC.vue?vue&type=style&index=0&id=b05056b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05056b0",
  null
  
)

export default component.exports